<template>
  <div
    :style="[
      showPrivacyPolicy ? { position: 'fixed' } : { overflow: 'hidden' },
    ]"
  >
    <div class="relative pt-1 custome-progress">
      <div class="overflow-hidden h-1 mb-4 text-xs flex rounded bg-green-200">
        <div
          class="
            w-full
            shadow-none
            flex flex-col
            text-center
            whitespace-nowrap
            text-white
            justify-center
            bg-green-500
          "
        ></div>
      </div>
    </div>
    <div class="sign_contract_block">
      <div class="body_inner">
        <div class="checkerroe_block">
          <div
            class="
              w-full
              reative
              mb-3
              text-sm text-size
              font-medium
              pl-8
              accept-check
            "
          >
            <label class="custome_check absolute top-0 left-1.5 w-5 h-5">
              <input v-model="confirmAgreement" type="checkbox" />
              <span class="checkmark"></span>
              <span class="font-normal"> </span>
            </label>
            {{ $t("pages.accept_contract.checkbox.first") }}
            <a @click="showPrivacyPolicy = true">
              {{ $t("pages.accept_contract.checkbox.second") }}
            </a>
            {{ $t("pages.accept_contract.checkbox.third") }}
          </div>
          <h4 class="text-left">
            {{ $t("pages.accept_contract.employee_agreement") }}
          </h4>
          <h5>{{ $t("pages.accept_contract.salutation") }} {{ lastName }},</h5>
        
          <p class="text-left">
            {{ $t("pages.accept_contract.first_pair") }}
          </p>
          <p class="text-left">
            {{ $t("pages.accept_contract.second_pair") }}
          </p>
          <p class="text-left">
            {{ $t("pages.accept_contract.third_pair") }}
          </p>
         
          <div id="actionblock" class="action_block actionfixed_block h-32">
            <button
              :class="{
                'disabled:opacity-50': !confirmAgreement,
              }"
              :disabled="!confirmAgreement"
              class="
                w-full
                flex
                items-center
                justify-center
                btn_apply
                rounded-g
                text-white
                btn_action
              "
              @click="redirectToSearchPage(true)"
            >
              {{ $t("pages.accept_contract.buttons.accept") }}
            </button>

            <div class="shape_icon">
              <svg
                width="375"
                height="372"
                viewBox="0 0 375 372"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="375" height="372" fill="url(#paint0_linear)" />
                <defs>
                  <linearGradient
                    id="paint0_linear"
                    x1="187.5"
                    y1="0"
                    x2="187.5"
                    y2="372"
                    gradientUnits="userSpaceOnUse"
                  >
                    <stop stop-color="white" stop-opacity="0" />
                    <stop offset="0.675296" stop-color="white" />
                  </linearGradient>
                </defs>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>
    <privacy-policy
      v-if="showPrivacyPolicy"
      @hideMe="showPrivacyPolicy = false"
    />
  </div>
</template>

<script>
import PrivacyPolicy from "@/pages/signup/PrivacyPolicy";
export default {
  name: "AcceptContract",
  components: { PrivacyPolicy },
  data() {
    return {
      confirmAgreement: false,
      lastName: "",
      showPrivacyPolicy: false,
    };
  },
  created() {
    if (!this.$store.getters["user/auth"].newUser) {
      this.$router.push({ name: "confirmCell" });
    }
  },
  mounted() {
    this.lastName = this.$store.getters["user/auth"].lastname;
  },
  methods: {
    readMore() {
      let moreText = document.getElementById("more");
      let element = document.getElementById("actionblock");
      if (moreText.style.display === "none") {
        moreText.style.display = "inline";
        element.classList.add("action_relaive");
      }
    },
    redirectToSearchPage(isLoggedIn) {
      this.$store
        .dispatch("user/acceptContract")
        .then((res) => {
          this.$router.push({ name: "offerSearch" });
        })
        .catch((err) => {});
    },
  },
};
</script>

<style scoped>
.custome_check {
  position: absolute;
  width: 18px;
  height: 18px;
  left: 12px;
}
.custome_check .checkmark {
  position: absolute;
  width: 20px;
  height: 20px;
}
.accept-check a {
  color: #63b15b;
  text-decoration: none;
}
.sign_contract_block {
  display: block;
  position: relative;
  margin: 0 0 0;
}

.sign_contract_block h4 {
  font-size: 22px;
  text-align: left;
  width: 100%;
  color: #333333;
  font-weight: bold;
  margin: 0 0 10px;
}

.sign_contract_block p {
  color: #676666;
  text-align: left;
  font-size: 16px;
  font-weight: normal;
  font-weight: 400;
  margin: 0 0 15px;
}

.sign_contract_block .checkerroe_block {
  display: block;
}
.sign_contract_block .action_block {
  width: 100%;
  margin: 10px 0 0;
  position: relative;
  left: 0;
  bottom: 0;
  
  padding: 0 3vw 20px;
}
.sign_contract_block .action_block.action_relaive {
  position: relative;
  background: transparent;
  padding-top: 0;
}
.sign_contract_block .action_block button {
  margin-top: 10px;
  height: 44px;
  font-weight: 600;
  position: relative;
  z-index: 99999;
}

.sign_contract_block .action_block .btn_goback {
  color: #63b15b !important;
  background: transparent !important;
}

.sign_contract_block .action_block .btn_facebook {
  color: #3b5998 !important;
  background: transparent !important;
  border: 0 !important;
}

.sign_contract_block .action_block .shape_icon {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #fffc;
}

.sign_contract_block .action_block.action_relaive .shape_icon {
  display: none;
}

.sign_contract_block .action_block .btn_facebook svg {
  margin-right: 8px;
}

body {
  padding-bottom: 0 !important;
}

.sign_contract_block .action_block .shape_icon svg {
  width: 100%;
  height: 100%;
}
/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
@media only screen and (max-width: 767px) {
  .sign_contract_block h4 {
    font-size: 17px;
  }
  .sign_contract_block p {
    font-size: 13px;
  }

  .sign_contract_block .action_block .shape_icon {
    width: 100%;
    height: 100%;
    background-color: #fffc;
  }

  .sign_contract_block .action_block .shape_icon svg {
    width: 100%;
    height: 100%;
  }
}
.bg-green-500 {
  background: #63b15b;
}
.text-size {
  font-size: 13px;
}
/*-----------------------  Responsive code ------------------*/
/*-----------------------  Responsive code ------------------*/
</style>
